import { reactive, ref } from 'vue'

interface RouteLike {
  path: string
  fullPath: string
  query: Record<string, string>
  params: Record<string, string>
}

function buildQuery(): Record<string, string> {
  if (typeof window === 'undefined') {
    return {}
  }

  const query: Record<string, string> = {}
  const params = new URLSearchParams(window.location.search)
  for (const [key, value] of params.entries()) {
    query[key] = value
  }
  return query
}

export function useRoute(): RouteLike {
  const path = typeof window !== 'undefined' ? window.location.pathname : '/'
  const fullPath = typeof window !== 'undefined' ? window.location.href : '/'

  return reactive({
    path,
    fullPath,
    query: buildQuery(),
    params: {}
  }) as RouteLike
}

export function useRuntimeConfig() {
  const defaults = {
    public: {
      apiUrl:
        (typeof window !== 'undefined' && (window as any).__NUXT__?.config?.public?.apiUrl) ||
        (typeof window !== 'undefined' && (window as any).__PAYMENT_FORM_API_URL__) ||
        'https://dev.donateou.org'
    }
  }

  return defaults
}

export function useHead(_: any) {
  // no-op in standalone environment
}

export function onNuxtReady(cb: () => void) {
  if (typeof window !== 'undefined') {
    if (document.readyState === 'complete' || document.readyState === 'interactive') {
      cb()
    } else {
      document.addEventListener('DOMContentLoaded', cb, { once: true })
    }
  }
}

export function useAsyncData<T>(key: string, handler: () => Promise<T>) {
  const data = ref<T | null>(null)
  const pending = ref(true)
  const error = ref<unknown>(null)

  handler()
    .then(result => {
      data.value = result
    })
    .catch(err => {
      error.value = err
    })
    .finally(() => {
      pending.value = false
    })

  return { data, pending, error }
}

export function useState<T>(key: string, init: () => T) {
  const stateKey = `__state_${key}`
  if (typeof window !== 'undefined') {
    const existing = (window as any)[stateKey]
    if (existing !== undefined) {
      return ref(existing) as any
    }
    const value = init()
    ;(window as any)[stateKey] = value
    return ref(value) as any
  }
  return ref(init()) as any
}

export function defineNuxtPlugin() {
  return () => ({})
}
